import React from 'react';

import {
  FILTER_PILLS,
  FilterPillKey,
  ICustomAPIFilterConfig,
} from '~/src/dash/components/filters/common';
import { MobileFilterPill } from '~/src/dash/components/filters/MobileFilterPill';
import { FONT_WEIGHT } from '~/src/dash/components/text/common';
import { Col, Cols, spacing, TextButton } from '~/src/dash/publicaUI';
import { IActiveFilters } from '~/src/dash/views/dashboards/DashboardHome/common/common';

const isFilterPillDisabled = (activeFilters: IActiveFilters, key: string, category?: string) => {
  const { demand, supply, device } = activeFilters;
  switch (category) {
    case 'demand':
      // this solves for an edge case. demand sources can be linked with device type
      const isDemandSourceFilter = key === 'Filtered Demand Sources';
      if (device && !isDemandSourceFilter) {
        return true;
      }
      if (supply && device) {
        return true;
      }
      break;
    case 'supply':
      if (demand && device) {
        return true;
      }
      break;
    case 'device':
      if (demand && demand !== 'Filtered Demand Sources') {
        return true;
      }
      break;
    default:
      return false;
  }
  return false;
};

interface IMobileFiltersRowProps {
  cfg: ICustomAPIFilterConfig;
  handleOpenFilter: (key: string) => void;
  activeFilters: IActiveFilters;
  handleClearAll: () => void;
  enableClearAll: boolean;
}

export const MobileFiltersRow = ({
  cfg,
  handleOpenFilter,
  activeFilters,
  handleClearAll,
  enableClearAll,
}: IMobileFiltersRowProps) => {
  return (
    <Cols
      gap={spacing.small}
      className='hide-scrollbar'
      style={{
        alignItems: 'center',
        overflowX: 'auto',
      }}
    >
      {enableClearAll && (
        <Col style={{ paddingRight: '8px' }}>
          <TextButton
            size='small'
            style={{ fontWeight: FONT_WEIGHT.base }}
            onClick={handleClearAll}
          >
            Clear All
          </TextButton>
        </Col>
      )}
      {Object.entries(cfg).map(([key, value]) => {
        const { category } = value;
        const { icon, menuTitle } = FILTER_PILLS[key as FilterPillKey];
        return (
          <Col>
            <MobileFilterPill
              active={!!category && activeFilters[category] === key}
              disabled={isFilterPillDisabled(activeFilters, key, category)}
              onClick={() => handleOpenFilter(key)}
              size='small'
              value={menuTitle}
              icon={icon}
            />
          </Col>
        );
      })}
    </Cols>
  );
};
